export const SUB_JOB_STATUS = {
  scheduled: { label: "Scheduled", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300" },
  in_progress: { label: "In Progress", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300" },
  completed: { label: "Completed", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300" },
  cancelled: { label: "Cancelled", color: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300" },
};

export const isParentJob = (job) => !!(job?.sub_job_summary?.total);
export const isSubJob = (job) => !!job?.parent_job_id;

/* "2/4 sub-jobs" pill */
export function SubJobChip({ summary, className = "", testid }) {
  if (!summary?.total) return null;
  const done = summary.completed + summary.cancelled;
  const allDone = done === summary.total;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap ${allDone ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/20 dark:text-emerald-200" : "bg-violet-100 text-violet-800 dark:bg-violet-500/20 dark:text-violet-200"} ${className}`}
      title={`${summary.completed} completed · ${summary.in_progress} in progress · ${summary.scheduled} scheduled${summary.cancelled ? ` · ${summary.cancelled} cancelled` : ""}`} data-testid={testid}>
      {summary.completed}/{summary.total} sub-jobs
    </span>
  );
}

/* Segmented progress bar: completed (green) · in progress (amber) · cancelled (grey) · remaining */
export function SubJobProgressBar({ summary, className = "", testid }) {
  if (!summary?.total) return null;
  const pct = (n) => `${(n / summary.total) * 100}%`;
  return (
    <div className={className} data-testid={testid}>
      <div className="flex h-2 w-full overflow-hidden rounded-full bg-muted">
        <div className="bg-emerald-500 transition-[width] duration-500" style={{ width: pct(summary.completed) }} />
        <div className="bg-amber-400 transition-[width] duration-500" style={{ width: pct(summary.in_progress) }} />
        <div className="bg-slate-300 dark:bg-slate-600 transition-[width] duration-500" style={{ width: pct(summary.cancelled) }} />
      </div>
      <p className="text-[10px] text-muted-foreground mt-1" data-testid={testid ? `${testid}-label` : undefined}>
        {summary.completed} of {summary.total} complete{summary.in_progress ? ` · ${summary.in_progress} in progress` : ""}{summary.cancelled ? ` · ${summary.cancelled} cancelled` : ""}
        {summary.open === 0 && summary.completed > 0 ? " · all done" : ""}
      </p>
    </div>
  );
}
